import React, { createContext, useContext, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

interface DemoContextType {
  isDemoMode: boolean;
  enterDemo: () => void;
  exitDemo: () => void;
}

const DemoContext = createContext<DemoContextType>({
  isDemoMode: false,
  enterDemo: () => {},
  exitDemo: () => {},
});

export const useDemo = () => useContext(DemoContext);

export const DemoProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isDemoMode, setIsDemoMode] = useState(() => localStorage.getItem('demo_mode') === 'true');

  const enterDemo = useCallback(() => {
    localStorage.setItem('demo_mode', 'true');
    setIsDemoMode(true);
  }, []);

  const exitDemo = useCallback(() => {
    localStorage.removeItem('demo_mode');
    setIsDemoMode(false);
  }, []);

  return <DemoContext.Provider value={{ isDemoMode, enterDemo, exitDemo }}>{children}</DemoContext.Provider>;
};
